import { IRootState } from '../../../store'
import { IDiagnosisState } from '../store/diagnosis.types'

export const getDiagnosisSelector = (state: IRootState): IDiagnosisState => state.diagnosis
